import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure61 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        height: '600px',
        type: 'bar',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#a5a5a5', '#5b9bd5', '#4472c4',],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },
  
  
      xAxis: [{
        categories: [
            "Monde",
            "",
            "Australie et Nouvelle-Zélande*",
            "Europe et Amérique du Nord",
            "Afrique du Nord et Asie de l’Ouest",
            "América Latina y el Caribe",
            "Asie de l’Est et du Sud-Est ",
            "Asie centrale et du Sud",
            "Océanie (hors Australie et Nouvelle-Zélande)",
            "Afrique subsaharienne",
            "",
            "Pays les moins avancés",
            "Petits États insulaires en développement",   
        ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
  
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          	format: '{value}',
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 5,
        min: 1,
        tickInterval: 1,
     
        title: {
          text: null,
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: '2018',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
  
        },
        data: [3,
        0,
      3,
    4,
  4,
4,
4,
3,
4,
4,
0,
4,
4,]
      },{
        name: '2020',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
  
        },
        data: [4,
        0,
      2,
    4,
  5,
4,
4,
2,
4,
4,
0,
4,
4,]
      },{
        name: '2022',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
  
        },
        data: [5,
        0,
      0,
    5,
  4,
4,
4,
3,
5,
4,
0,
4,
4,]
      },
    ]

}
